
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 13.16 10.039\" id=\"icon-tick\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M13.039,1.864L4.985,9.918c-0.07,0.07-0.161,0.104-0.252,0.113c-0.013,0.001-0.025,0.008-0.039,0.008\r\n\tc-0.105,0-0.21-0.04-0.291-0.121L0.12,5.635c-0.16-0.161-0.16-0.421,0-0.582l1.163-1.163c0.161-0.161,0.421-0.161,0.582,0l2.83,2.83\r\n\tl6.601-6.601c0.161-0.16,0.421-0.16,0.582,0l1.163,1.163C13.2,1.443,13.2,1.704,13.039,1.864z\"/> </symbol>";
module.exports = sprite.add(image, "icon-tick");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/tick.svg
 ** module id = 233
 ** module chunks = 24
 **/